import type { CashDenominationDto } from './cash-sessions.dto.js';

export const cashDenominationSnapshotKindValues = [
  'drawerManualCount',
  'vaultManualCount',
  'treasuryManualCount',
] as const;
export type CashDenominationSnapshotKind = (typeof cashDenominationSnapshotKindValues)[number];

export const cashDenominationSnapshotConfidenceValues = ['counted'] as const;
export type CashDenominationSnapshotConfidence =
  (typeof cashDenominationSnapshotConfidenceValues)[number];

// Minor-unit values for supported USD cash and coin denominations.
export const supportedCashDenominationMinorValues = [
  10000, 5000, 2000, 1000, 500, 200, 100, 25, 10, 5, 1,
] as const;
export type SupportedCashDenominationMinor = (typeof supportedCashDenominationMinorValues)[number];

export interface CashCountedDenominationSnapshotDto {
  id: string;
  companyId: string;
  storeId: string | null;
  locationId: string | null;
  stationId: string | null;
  cashLocationId: string;
  snapshotKind: CashDenominationSnapshotKind;
  confidence: CashDenominationSnapshotConfidence;
  denominations: CashDenominationDto[];
  countedTotalMinor: number;
  countedByUserId: string;
  countedAt: string;
  cashSessionId: string | null;
  note: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCashCountedDenominationSnapshotRequest {
  companyId: string;
  operationId: string;
  occurredAt: string;
  storeId?: string | null;
  locationId?: string | null;
  stationId?: string | null;
  cashLocationId: string;
  snapshotKind: CashDenominationSnapshotKind;
  confidence: CashDenominationSnapshotConfidence;
  denominations: CashDenominationDto[];
  countedTotalMinor: number;
  countedAt: string;
  cashSessionId?: string | null;
  note?: string | null;
}

export interface CreateCashCountedDenominationSnapshotResponse {
  snapshot: CashCountedDenominationSnapshotDto;
}

export interface ListCashCountedDenominationSnapshotsRequest {
  companyId: string;
  storeId?: string;
  locationId?: string;
  stationId?: string;
  cashLocationId?: string;
  cashSessionId?: string;
  snapshotKind?: CashDenominationSnapshotKind;
  from?: string;
  to?: string;
}

export interface ListCashCountedDenominationSnapshotsResponse {
  items: CashCountedDenominationSnapshotDto[];
}

export interface GetCashCountedDenominationSnapshotRequest {
  companyId: string;
  snapshotId: string;
}

export interface GetCashCountedDenominationSnapshotResponse {
  snapshot: CashCountedDenominationSnapshotDto;
}
